module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-about-author element-with-heading",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "about-the-author-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Love crime, thriller and mystery books?")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "about-the-author-text"
    }
  }, [_c('div', {
    staticClass: "inline-image inline-image-kind-freestanding inline-image-size-large inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-begins-section inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "http://deals.bloodhoundbooks.com/bloodhound-deals",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/mailing-list-image-for-kindle.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Sign up today to be the first to hear about new releases and exclusive offers, including free and discounted ebooks!")]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "http://deals.bloodhoundbooks.com/bloodhound-deals",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/sign-up.jpg"
    }
  })])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Why not like us or follow us on social media to stay up to date with the latest news from your favourite authors?")]), _vm._v(" "), _c('div', {
    staticClass: "social-media-profiles as-icons"
  }, [_c('p', {
    staticClass: "social-profile"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/bloodhoundbooks",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "social-profile-image-decorator"
  }, [_c('span', {
    staticClass: "social-profile-image-size-container"
  }, [_c('img', {
    staticClass: "social-profile-image",
    attrs: {
      "alt": "Facebook icon",
      "src": "images/social-facebook-screen.png"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "social-profile-text"
  }, [_vm._v("Facebook")])])]), _vm._v(" "), _c('p', {
    staticClass: "social-profile"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/Bloodhoundbook",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "social-profile-image-decorator"
  }, [_c('span', {
    staticClass: "social-profile-image-size-container"
  }, [_c('img', {
    staticClass: "social-profile-image",
    attrs: {
      "alt": "Twitter icon",
      "src": "images/social-twitter-screen.png"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "social-profile-text"
  }, [_vm._v("Twitter")])])]), _vm._v(" "), _c('p', {
    staticClass: "social-profile"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/bloodhoundbooks_publishing",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "social-profile-image-decorator"
  }, [_c('span', {
    staticClass: "social-profile-image-size-container"
  }, [_c('img', {
    staticClass: "social-profile-image",
    attrs: {
      "alt": "Instagram icon",
      "src": "images/social-instagram-screen.png"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "social-profile-text"
  }, [_vm._v("Instagram")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36649061","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lovecrimethrillerandmysterybooks.vue
// module id = 69
// module chunks = 0